import React, { useEffect } from 'react'
import { withAppContext } from 'src/store/initAppContext';
import styled, { withTheme } from 'styled-components';
import { LazyLoadImage } from "react-lazy-load-image-component";
import config from "src/config/config";
import PlaceholderImage from 'src/components/Placeholder';
import { theme } from 'styled-tools';

function ILT20PromoFun(props) {
    const { app: {
        brandId
    }, theme } = props;

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <>
            <InformationWrapper>
                <Container>
                    <TopBanner>
                        <BannerText>
                            As the Front of Jersey Sponsor of <span className="dark-blue">Dubai Capitals</span> in <span className="red">ILT20</span>, <span className="light-blue">Fun88</span> is celebrating with a special season offer. Enjoy <strong>100% back</strong> on your first losing Exchange bet every day throughout the ILT20 season.
                        </BannerText>
                        <div className='staticImg'>
                            <LazyLoadImage
                                src={`${config.imageV3Host}/static/cashsite/${theme.image.iLT20PromoCricOneImg}`}
                                alt="How to Join"
                                effect="none"
                                placeholder={<PlaceholderImage />}
                            />
                        </div>
                    </TopBanner>

                    <SectionTitle>How It Works?</SectionTitle>

                    <Row>
                        <Card>
                            <CardText>
                                Open <span className="light-blue">Fun88</span> <strong>Exchange</strong>
                            </CardText>
                            <div className='staticImg2'>
                                <LazyLoadImage
                                    src={`${config.imageV3Host}/static/cashsite/${theme.image.iLT20PromoCricTwoImg}`}
                                    alt="Cricket One"
                                    effect="none"
                                    placeholder={<PlaceholderImage />}
                                />
                            </div>
                        </Card>

                        <Card>
                            <CardText>
                                Place Your Bets On <br /><span className="red">ILT20</span> <strong>Matches</strong>
                            </CardText>
                            <div className='staticImg3'>
                                <LazyLoadImage
                                    src={`${config.imageV3Host}/static/cashsite/${theme.image.iLT20PromosheildImg}`}
                                    alt="Sheild Img"
                                    effect="none"
                                    placeholder={<PlaceholderImage />}
                                />
                            </div>
                        </Card>
                    </Row>

                    <MiddleCard>
                        <MiddleText>If your first bet of the day loses, <br /><span className='dark-brown'>get 100% back the next day</span></MiddleText>
                        <div className='staticImg4'>
                            <LazyLoadImage
                                src={`${config.imageV3Host}/static/cashsite/${theme.image.iLT20PromoTrophyImg}`}
                                alt="Trophy Img"
                                effect="none"
                                placeholder={<PlaceholderImage />}
                            />
                        </div>
                    </MiddleCard>

                    <TermsSection>
                        <TermsTitle>Terms &amp; Conditions</TermsTitle>
                        <TermsList>
                            <li>Offer valid once per day.</li>
                            <li>Minimum qualifying bet amount: <strong>50 INR</strong> on ILT20 matches only.</li>
                            <li>Applicable <strong>only on Exchange bets</strong>.</li>
                            <li>Valid during ILT20 matches from <strong>2nd December 2025 to 4th January 2026</strong>.</li>
                            <li>Maximum refund amount: <strong>50 INR per day</strong>.</li>
                            <li>Terms and conditions apply.</li>
                        </TermsList>
                    </TermsSection>
                </Container>

            </InformationWrapper>
        </>
    )
}

export default withTheme(withAppContext(ILT20PromoFun));

const InformationWrapper = styled.div`
    width: 100%;
    height: auto;
    padding: 4rem 0 5rem 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #EBEBEB;
    overflow: hidden;
    color: #444;
    text-transform: capitalize;

    .staticImg {
        width: auto;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        right: 10px;
        bottom: -34px;
        z-index: 9;

        img {
            width: 175px;
            height: 208px;
            max-width: 100%;
        }
    }

    .staticImg2 {
        width: auto;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        right: 10px;
        bottom: 0;
        z-index: 9;

        img {
            width: 107px;
            height: 171px;
            max-width: 100%;
        }
    }

    .staticImg3 {
        width: auto;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        right: 10px;
        bottom: 0;
        z-index: 9;

        img {
            width: 160px;
            height: 175px;
            max-width: 100%;
        }
    }

    .staticImg4 {
        width: auto;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        right: 10px;
        bottom: 0;
        z-index: 9;

        img {
            width: 164px;
            height: 166px;
            max-width: 100%;
        }
    }

    span.dark-blue {
        color: #3241D3;
        font-weight: 800;
    }

    span.light-blue {
        color: #06A6FF;
        font-weight: 800;
    }
    
    span.red {
        color: #DE0000;
        font-weight: 800;
    }

    span.dark-brown {
        color: #444;
        font-weight: 800;
    }
`;

const Container = styled.div`
    width: 100%;
    max-width: 1100px;
`;

const TopBanner = styled.div`
    height: 127px;
    padding: 2.5rem;
    display: flex;
    align-items: center;
    position: relative;
    margin-bottom: 48px;
    background: #fff;
    border-radius: 10px;
`;

const BannerText = styled.p`
    margin: 0;
    font-size: 14px;
    line-height: 22px;
    max-width: 700px;
    text-transform: none;
`;

const SectionTitle = styled.h2`
    text-align: center;
    font-size: 18px;
    margin: 12px 0 42px;
    color: #06A6FF;
    text-transform: capitalize;
    font-weight: 700;
`;

const Row = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
    gap: 24px;
    margin-bottom: 40px;
`;

const Card = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 152px;
    position: relative;
    padding: 2.5rem;
    background: #fff;
    border-radius: 10px;
`;

const CardText = styled.div`
    font-size: 16px;
    max-width: 70%;

    span.blue {
        color: #3b82f6;
    }
    span.red {
        color: #ff493a;
    }
`;

const MiddleCard = styled(Card)`
    margin: 0 auto 40px;
    max-width: 720px;
`;

const MiddleText = styled.div`
    font-size: 15px;
    line-height: 1.7;
    text-transform: none;
`;

const TermsSection = styled.section`
    text-align: center;
    background: #fff;
    max-width: 720px;
    margin: 0 auto;
    padding: 2.5rem;
    padding-top: 1rem;
    border-radius: 10px;
`;

const TermsTitle = styled.h3`
    font-size: 18px;
    color: #06A6FF;
    margin-bottom: 25px;
`;

const TermsList = styled.ol`
  margin: 0 auto;
  padding-left: 22px;
  text-align: left;
  max-width: 640px;
  font-size: 14px;
line-height: 28px;
color: #444;

  strong {
    font-weight: 700;
  }
`;